import { Contrato } from "../../../types/contratos";

/** Interpreta 'YYYY-MM-DD' (ou 'YYYY-MM-DD HH:mm:ss') como data LOCAL à meia-noite,
 *  sem o deslocamento de fuso que `new Date('YYYY-MM-DD')` (UTC) causa. */
export const parseDataContratoLocal = (valor: string): Date => {
  const [ano, mes, dia] = valor.slice(0, 10).split('-').map(Number);
  return new Date(ano, mes - 1, dia);
};

const hojeLocal = (): Date => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

/** Vencido = situação 'Vencido' OU data_finalizacao ANTERIOR a hoje (data pura).
 *  Contrato que vence hoje NÃO é vencido — alinha com o card do dashboard
 *  (`$sqlVencer`: data_finalizacao >= CURDATE()). */
export const isContratoVencido = (contrato: Contrato): boolean => {
  if (contrato.situacao === "Vencido") return true;
  if (!contrato.data_finalizacao) return false;
  return parseDataContratoLocal(contrato.data_finalizacao) < hojeLocal();
};

/** A vencer = não vencido e data_finalizacao em [hoje, hoje + 3 meses] (data pura). */
export const isContratoAVencer = (contrato: Contrato): boolean => {
  if (isContratoVencido(contrato)) return false;
  if (!contrato.data_finalizacao) return false;
  const fim = parseDataContratoLocal(contrato.data_finalizacao);
  const hoje = hojeLocal();
  const limite = hojeLocal();
  limite.setMonth(limite.getMonth() + 3);
  return fim >= hoje && fim <= limite;
};
